<div class="welcome">
  <div>
      <p>Welcome to the study. Before we begin, please complete the following challenge. </p>
  </div>
</div>

<div class="center">
    <form [formGroup]="aFormGroup">
        <ngx-recaptcha2 #captchaElem
          [siteKey]="siteKey"
          (success)="handleSuccess($event)"
          formControlName="recaptcha"
          >
        </ngx-recaptcha2>
    </form>
</div>
